<template>
       
    <div v-if="data.hex.length > 1"
        :class="[
            'card',
            'colour-card',
            'colour-card--' + theme,
            'location--' + location,
            data.state,
            (data.hex.length <= 1) ? 'disabled' : null
        ]"
        :style="{
            marginBottom: isShowLabelOnHover ? '' : '0'
        }"
    >
            <a v-if="useOvelay===true" :href="data.link" class="colour-sample-selector" @click.prevent="animateNavTo"></a>
            
            <div v-else>
                <a v-if="data.link && !disableLink" :href="data.link" class="colour-sample-selector tested"></a>
            </div>

            <div class="colour-sample-selector-backdrop"></div>
            <div v-if="data.allowFavourites" @mouseover.self="tooltipinfoHoverIn($event, 'Add to Moodboard')" @mouseleave.self="tooltipinfoHoverOut($event)" ref="addFav" class="fav add-fav" :data_id="data.id" :class="data.isFavorite" @click="addFav(data.id)" data-category="MoodBoard" data-action="Click" data-label="Heart"></div>
            <div v-if="data.allowFavourites" @mouseover.self="tooltipinfoHoverIn($event, 'Remove from Moodboard')" @mouseleave.self="tooltipinfoHoverOut($event)" ref="removeFav" class="fav remove-fav" :class="data.isFavorite " @click="removeFav(data.id)" data-category="MoodBoard" data-action="Click" data-label="Heart"></div>
            <div :class="'colour-circle colour-circle--' + data.size" :style="{ backgroundColor: data.hex, marginTop: isShowLabelOnHover ? '' : '0' }">
                <div v-if="data.isNewColour" class="colour-new-ribbon"></div>
                <div v-if="data.outofStock" class="out-of-stock">
                    <span v-if="data.outofStockMessage">{{data.outofStockMessage}}</span>
                    <span v-else>Out of Stock</span>
                </div>
                <img v-if="data.icon" :src="data.icon" :alt="data.title" style="max-width: 100%;">
                <!--
                <img v-if="data.iconSvg" :src="data.iconSvg" :alt="data.title" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;">
                -->
            </div>
            <div v-if="isShowLabelOnHover" class="info">
                
                <div v-if="data.name" class="title">
                    <span v-if="data.type">{{data.type}}: </span>
                    <span v-if="isTitleLinebreak" v-html="isLinebreakString(data.name)"></span>
                    <span v-else>{{data.name}}</span>
                </div>

                <div v-if="data.hovername" class="hovername">{{data.hovername}}</div>
                <div v-if="data.tsr" class="colour-info">TSR: {{data.tsr}}%</div>
                <div v-if="data.lrv" class="colour-info">LRV: {{data.lrv}}%</div>
                
            </div>
        
    </div>

</template>

<script>
import axios from 'axios';

export default {
    name: "colour-card",
    components: {
        // Fragment
    },
    props: {
        data: {
            type: Object
        },
        theme: {
            type: String
        },
        useOvelay: {
            type: Boolean
        },
        location: {
            type: String
        },
        isTitleLinebreak: {
            type: Boolean
        },
        location: {
            type: String
        },
        isShowLabelOnHover: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        disableLink () {
            return this.location==='inspirationGallery' || this.location==='moodboardModal' || this.location==='moodboardIdeas';
        }
    },
    methods: {
        isLinebreakString (string) {
            let parts = string.split(" ");
            return parts.join('<br>');
        },

        animateNavTo(ev) {
            let target = ev.target.tagName==='A' ? ev.target : ev.target.closest("a");
            this.linkOverlayShow(target.href);
        },
        addFav (id) {
            const e1 = this.$el.querySelector(".add-fav").classList;
            const e2 = this.$el.querySelector(".remove-fav").classList;

            e2.add('d-block');
            e2.add('opacity-none');
            setTimeout(() => {
                e2.add('opacity-one');
                e2.remove('opacity-none');
            }, 25);
            setTimeout(() => {
                e1.add('selected');
                e2.add('selected');

                e2.remove('d-block');
                e2.remove('opacity-one');
            }, 275);

            axios.get(`/moodboardapi/item/${id}/toggle/?${Date.now()}`)
                .then(response => {
                    const message = {
                        title: 'Item added to moodboard',
                        text: '<a href="/inspiration/mood-board/">Item added to moodboard</a>',
                    }
                    
                    this.appendtoNotification(message);
                    this.toggleNotificationMoodboard();
                })
                .catch(error => {
                    console.log(error);
                })
            

        },

        removeFav (id) {
            const e1 = this.$el.querySelector(".add-fav").classList;
            const e2 = this.$el.querySelector(".remove-fav").classList;

            e1.remove('selected');
            e2.add('d-block');
            e2.add('opacity-one');
            setTimeout(() => {
                e2.add('opacity-none');
                e2.remove('opacity-one');
            }, 25);
            setTimeout(() => {
                e2.remove('selected');
                e2.remove('opacity-one');
                e2.remove('d-block');
            }, 275);


            var classes = this.$el.querySelector(".remove-fav").classList;
            var classStr = classes.value;
            var hasRemove = classStr.includes("fav remove-fav remove");

            
            this.$el.classList.add('fade-out');
            axios.get(`/moodboardapi/item/${id}/toggle/?${Date.now()}`)
                .then(response => {
                    const message = {
                        title: 'Item removed from moodboard',
                        text: '<a href="/inspiration/mood-board/">Item removed from moodboard</a>',
                    }
                    
                    this.appendtoNotification(message);
                    this.toggleNotificationMoodboard();
                })
                .catch(error => {
                    console.log(error);
                })

        },
    }
};
</script>

<style lang="scss" scoped>

@import "../../../scss/abstracts/variables";

.colour-card {
    display: block;
    text-align: center;
    position: relative;
    background: transparent;


    &.disabled{
        visibility: hidden;
        width: 0px;

    }

    &.fade-out {
        visibility: hidden;
        opacity: 0;
        transition: visibility 0s 2s, opacity 2s linear;
        display: none;
    }

    .colour-circle {
        position: relative;
        border-radius: 50%;
        margin: 1rem 0;
        background-color: $color-grey-light;

        &--small {
            width: 50px;
            height: 50px;
        }

        &--medium {
            width: 80px;
            height: 80px;
        }

        &--large {
            width: 150px;
            height: 150px;
        }

        .out-of-stock {
            position: absolute;
            z-index: 10;
            background-color: #fff;
            cursor: pointer;
            // width: 15px;
            width: 100%;
            min-height: 25px;
            top: 45%;
            right: 0;
            // right: 1rem;
            // background-position: center;
            // background-repeat: no-repeat;
            // background-size: 20px;
            // background-image: url('#{$dir-images}icons/close-white.svg');
            transition: all 300ms;
            text-align: center;
        }

        .colour-new-ribbon {
            position: absolute;
            z-index: 11;
            cursor: pointer;
            pointer-events: none;
            height: 100%;
            width: 100%;
            top: 0;
            right: 0;
            background-image: url('#{$dir-images}colour/new-color-ribbon.png');
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
        }
    }

    .info {
        width:150px;
        
        .title {
            margin: 0 0 .6rem;
        }

        .hovername {
            visibility: hidden;
            opacity: 0;
            transition: visibility 0s 2s, opacity 2s linear;
            display: none;
            margin: 0 0 .6rem;
        }

        .colour-info {
            font-family: $font-secondary;
        }
    }

    .fav {
            position: absolute;
            z-index: 3;
            display: block;
            width: 30px;
            height: 30px;
            background-image: url('#{$dir-images}icons/fav-dark.svg');
            background-position: center top;
            background-size: 100%;
            background-repeat: no-repeat;
            top: 1rem;
            right: 1rem;

            &.remove-fav {
                display: none;
                &.selected {
                    display: block;
                    background-image: url('#{$dir-images}icons/fav-active-dark.svg');
    
                    &.remove {
                        cursor: pointer;
                        width: 20px;
                        height: 20px;
                        background-image: url('#{$dir-images}icons/close.svg');
                    }
                }
            }

            &.add-fav {
                display: block;
                &.selected {
                    display: none;
                    
                }
            }

            &.selected {

                &.remove {
                    background-image: url('#{$dir-images}icons/close.svg');
                }
            }

            
        }

    &.selected {
        .colour-circle {
            &::before {
                content: "";
                display: block;
                width: 60px;
                height: 60px;
                border-radius: 50%;
                background-color: $color-primary;
                background-image: url('#{$dir-images}icons/tick.svg');
                background-repeat: no-repeat;
                background-position: center;
                background-size: 30px;
                position: absolute;
                top: calc(50% - 30px);
                left: calc(50% - 30px);
                pointer-events: none;
            }
        }

        .remove {
            background-image: url('#{$dir-images}icons/close.svg');
            background-size: 20px;
            background-position: center;
            background-repeat: no-repeat;
            width: 30px;
            height: 30px;
            position: absolute;
            right: 5px;
            top: 5px;
            cursor: pointer;
        }
    }
}

.views-content--case-studies,
.views-content--inspiration-gallery,
.moodboard-content-template {
    .colour-card {
        // margin-bottom: 0;

        .colour-circle {
            margin: 0;
        }
    }
}

.colour-card--default {
    padding: 1rem 0;
    margin: 1rem 0;
    background: $brand-white;
    transition: all .3s $sharp-curve;

    &:hover {
        box-shadow: 0 10px 20px 0 rgb(48 70 89 / 20%);
    }
}

.colour-card--visualiser {
    padding: 1rem 0;
    margin: 2px 0;
    background: $brand-white;
    transition: all .3s $sharp-curve;

    .colour-circle {
        margin: 0 auto;
        margin-bottom: 1rem;
    }
    
    &.selected {
        .colour-circle {
            &::before {
                content: "";
                display: block;
                width: 50px;
                height: 50px;
                border-radius: 50%;
                background-color: $color-primary;
                background-image: url('#{$dir-images}icons/tick.svg');
                background-repeat: no-repeat;
                background-position: center;
                background-size: 30px;
                position: absolute;
                top: calc(50% - 25px);
                left: calc(50% - 25px);
                pointer-events: none;
            }
        }

        .remove {
            background-image: url('#{$dir-images}icons/close.svg');
            background-size: 20px;
            background-position: center;
            background-repeat: no-repeat;
            width: 30px;
            height: 30px;
            position: absolute;
            right: 5px;
            top: 5px;
            cursor: pointer;
        }
    }

    .info {
        width: inherit;
    }

    &:hover {
        box-shadow: 0 10px 20px 0 rgb(48 70 89 / 20%);
        
        .hovername {
            visibility: visible;
            opacity: 1;
            transition: visibility 0s 2s, opacity 2s linear;
            display: block;
        }
    }
}

.colour-card--simple {
    .remove {
        display: none;
    }

    .info {
        display: none;
    }

    .colour-sample-selector {
        width: 100%;
    }

    .colour-sample-selector-backdrop {
        display: none !important;
    }
}


.colour-sample-selector{
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;
    width: 150px;
    z-index: 2;

    &:hover{

        & + .colour-sample-selector-backdrop{
            display: block;

        }

       
       

    }

}
.colour-sample-selector-backdrop{
            display: none;
            background-color: white;
            width: 190px;
            height: calc(100% + 40px);
            box-shadow: 0 10px 20px 0 rgb(48 70 89 / 20%);
            position:absolute;
            top:-20px;
            left: -20px;
            z-index: -1;

}

</style>
